<template>
  <v-layout :loading="loading">
    <template v-if="!loading">
      <d-header
        fluid
        :actions="[
          {
            label: $t('save'),
            primary: true,
            color: 'is-primary',
            action: submitForm,
          },
        ]"
      >
        <h1 class="title">
          {{ model.name }}
        </h1>
      </d-header>

      <div class="max-w-3xl">
        <v-form
          ref="form"
          action="edit"
          :model="model"
        />
      </div>
    </template>
  </v-layout>
</template>

<script>
import form from "./_form.vue";

export default {
  metaInfo() {
    return {
      title: this.title,
      __owner: this.title, // for breadcrumb
    };
  },
  components: {
    "v-form": form,
  },
  data() {
    return {
      model: {},
      loading: true,
    };
  },
  computed: {
    title() {
      if (this.model.name) {
        return this.model.name;
      }
      return "";
    },
  },
  watch: {
    "$route.params.owner"() {
      this.fetch();
    },
  },
  created() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.loading = true;
      this.$http
        .get(
          this.$laravel.route("api.owners.show", {
            owner: this.$route.params.owner,
          })
        )
        .then((response) => {
          this.loading = false;
          this.model = response.data.data;
        })
        .catch((e) => {
          console.error(e);
          this.$router.push("/owners");
        });
    },
    submitForm() {
      this.$refs.form.$refs.form.submit();
    },
  },
};
</script>
